import React from 'react'
import { useGeckoTheme } from 'styles/GeckoTheme'

export const DimensionsIcon: React.FC<{
  show3D: boolean
}> = ({ show3D }) => {
  const { theme } = useGeckoTheme()
  return show3D ? (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke={theme.forecast.icon1}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 5V12.9667L5 17M12 12.9667L19 17'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 6L12 3L15 6'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20 14L21.0981 18.0981L17 19.1962'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.59808 14L3.5 18.0981L7.59808 19.1962'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ) : (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke={theme.forecast.icon1}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5 3V19H21'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 6L5 3L8 6'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 16L21 19L18 22'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
